<template>
  <div>
    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon"
      :breadcrumbs="page.breadcrumbs" :exportOptions="page.exportOptions" @openFilter="openPerformanceReportFilter"
      @refreshPage="refreshPerformanceReportPage" :isMaterialIconType="true" @exportData="exportPerformanceReportReport"
      @toggleClick="toggleClick" :style="styleObject">
    </section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="getheaders" :items="performance_report" class="elevation-1" :pagination.sync="pagination"
        :total-items="agentperformancetotal" :rows-per-page-items="[5, 10, 25]">
        <template v-slot:items="props" v-if="page.viewing == '1'">
          <td class="checkEmpty p0">{{ props.item.calldate }}</td>
          <td class="checkEmpty p0">{{ props.item.start_time }}</td>
          <td class="checkEmpty p0">{{ props.item.end_time }}</td>
          <td class="checkEmpty p0">{{ props.item.campaign }}</td>
          <td class="checkEmpty p0">{{ props.item.agent }}</td>
          <td class="checkEmpty p0">{{ props.item.team }}</td>
          <!-- <td class="checkEmpty p0">{{ props.item.login_count }}</td> -->

          <td class="checkEmpty p0">
            {{
              props.item.answer +
              props.item.unanswer +
              props.item.inbound_unanswer
            }}
          </td>
          <td class="checkEmpty p0">{{ props.item.inbound }}</td>
          <td class="checkEmpty p0">{{ props.item.inbound_unanswer }}</td>
          <td class="checkEmpty p0">{{ props.item.outbound }}</td>
          <td class="checkEmpty p0">{{ props.item.unanswer }}</td>
          <!-- <td class="checkEmpty">{{ props.item.inbound }}</td>
          <td class="checkEmpty">{{ props.item.outbound }}</td>
          <td class="checkEmpty">{{ props.item.preview }}</td>
          <td class="checkEmpty">{{ props.item.dialer }}</td>-->
        </template>
        <template v-slot:items="props" v-else>
          <td class="checkEmpty p0">{{ props.item.calldate }}</td>
          <td class="checkEmpty p0">{{ props.item.start_time }}</td>
          <td class="checkEmpty p0">{{ props.item.end_time }}</td>
          <td class="checkEmpty p0">{{ props.item.campaign }}</td>
          <td class="checkEmpty p0">{{ props.item.agent }}</td>
          <td class="checkEmpty p0">{{ props.item.team }}</td>
          <!-- <td class="checkEmpty p0">{{ props.item.login_count }}</td> -->
          <td class="checkEmpty p0">{{ props.item.login }}</td>
          <td class="checkEmpty p0">{{ props.item.billing_break }}</td>
          <td class="checkEmpty p0">{{ props.item.non_billing_break }}</td>
          <td class="checkEmpty p0">{{ props.item.break }}</td>
          <td class="checkEmpty p0">{{ props.item.total_billing_break }}</td>
          <td class="checkEmpty">{{ props.item.wrap }}</td>
          <td class="checkEmpty">{{ props.item.breach }}</td>
          <td class="checkEmpty p0">{{ props.item.talktime }}</td>
          <td class="checkEmpty p0">{{ props.item.idle }}</td>
          <td class="checkEmpty p0">{{ props.item.avg_talk }}</td>
          <td class="checkEmpty p0">{{ props.item.ring }}</td>
          <td class="checkEmpty p0">{{ props.item.handle_time }}</td>
   
        </template>
      </v-data-table>
    </v-container>
    <!-- <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="1000">
          <pdfexport
            v-if="dialog"
            :header="pdf.header"
            :pdfdata="pdf_data"
            @closeModel="closeModel"
            title="Performance Report"
          ></pdfexport>
        </v-dialog>
      </v-layout>
    </div> -->
    <v-navigation-drawer fixed disable-resize-watcher right v-model="page.isFilterOpen" class="filterNavigation">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
        <v-container class="sidenavContainer">
          <div class="datetimefilter">
            <label>From Date</label>
            <v-container class="pa-1">
              <v-menu v-model="page.menu.fromdate" :close-on-content-click="false" full-width max-width="290" small>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="appliedfilter.fromdate" label="" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker color="primary" :max="new Date().toISOString().split('T')[0]"
                  v-model="appliedfilter.fromdate" @change="page.menu.fromdate = false">
                </v-date-picker>
              </v-menu>
            </v-container>
            <label>From Interval</label>
            <v-autocomplete v-model="appliedfilter.fromtime" :items="fromtimedata" label="" persistent-hint small
              single-line :allow-overflow="false" item-disabled="active" item-text="displayname"
              item-value="value"></v-autocomplete>
            <label>To Date</label>
            <v-container class="pa-1">
              <v-menu v-model="page.menu.todate" :close-on-content-click="false" full-width max-width="290" small>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="appliedfilter.todate" label="" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker color="primary" v-model="appliedfilter.todate"
                  :max="new Date().toISOString().split('T')[0]" :min="appliedfilter.fromdate"
                  @change="page.menu.todate = false">
                </v-date-picker>
              </v-menu>
            </v-container>
            <label>To Interval</label>
            <v-autocomplete v-model="appliedfilter.totime" :items="totimedata" label="" persistent-hint small
              single-line :allow-overflow="false" item-disabled="active" item-text="displayname"
              item-value="value"></v-autocomplete>
          </div>
          <br>

          <br>
          <v-autocomplete v-model="appliedfilter.agent" :items="filteragents" label="Agent" persistent-hint small
            multiple single-line :allow-overflow="false"></v-autocomplete>
          <v-autocomplete v-model="appliedfilter.campaign" :items="filters.campaign" label="Campaign" persistent-hint
            small single-line :allow-overflow="false">
          </v-autocomplete>
        </v-container>

        <v-container row class="sidenavFooter">
          <v-btn flat @click="resetvalue()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="(appliedfilter.totime === '' || appliedfilter.todate === '') ? true : false" color="primary"
            @click="getDataFrom()">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
import { mapGetters } from "vuex";
// import pdfexport from "./Components/pdfexport";
import moment from "moment";
export default {
  components: {
    loader,
    // pdfexport,
  },

  mounted() {
    let scope = this;
    this.page.loading = false;
    this.page.loading = false;
    let teams = JSON.parse(localStorage.getItem("Team"))
    let team_agent_user = JSON.parse(localStorage.getItem("Team_agent_user"))
    if (teams.length > 0 && team_agent_user.length > 0) {
      this.filteragents = team_agent_user
    } else {
      this.filteragents = JSON.parse(localStorage.getItem("agent_emails"));
    }
    // this.$store.dispatch("reportuserlist").then(() => {
    //   // this.getDataFromApi();
    //   this.dateformate();
    // });
    this.dateformate();
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "reports:agentperformance:export"
          ) !== -1
        ) {
          scope.page.exportOptions = ["CSV", "Txt(Tab-Delimited)"];
        } else {
          scope.page.exportOptions = [];
        }
      }.bind(scope),
      1
    );
    this.getDataFromApi();
  },
  computed: {

    getheaders: function () {
      if (this.page.viewing == "1") {
        return this.headers1;
      } else {
        return this.headers2;
      }
    },
    ...mapGetters([ "filters"]),
  },
  data() {
    return {
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Agent Hourly Performance Report",
        icon: "network_check",
        loading: true,
        materialicon: true,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        options: { filter: true, refresh: true, toggleButton: true, tab: ['Calls', 'Time'] },
        exportOptions: [],

        viewing: "1",
        menu: {
          fromdate: false,
          todate: false,
        },
      },
      payload: {
        from_date: "",
        to_date: "",
        skip: 0,
        take: 0,
        agent: "",
        detail: "performance",
        descending: "",
        export: "Performancereport",
      },
      total: "",
      call_date: "",
      report: "",
      exports: [],
      excel_data: [],
      pdf_data: [],
      txt_data: [],
      filteragents: [],
      fromtimedata: [
        { displayname: "00:00", value: 0, active: false },
        { displayname: "01:00", value: 1, active: false },
        { displayname: "02:00", value: 2, active: false },
        { displayname: "03:00", value: 3, active: false },
        { displayname: "04:00", value: 4, active: false },
        { displayname: "05:00", value: 5, active: false },
        { displayname: "06:00", value: 6, active: false },
        { displayname: "07:00", value: 7, active: false },
        { displayname: "08:00", value: 8, active: false },
        { displayname: "09:00", value: 9, active: false },
        { displayname: "10:00", value: 10, active: false },
        { displayname: "11:00", value: 11, active: false },
        { displayname: "12:00", value: 12, active: false },
        { displayname: "13:00", value: 13, active: false },
        { displayname: "14:00", value: 14, active: false },
        { displayname: "15:00", value: 15, active: false },
        { displayname: "16:00", value: 16, active: false },
        { displayname: "17:00", value: 17, active: false },
        { displayname: "18:00", value: 18, active: false },
        { displayname: "19:00", value: 19, active: false },
        { displayname: "20:00", value: 20, active: false },
        { displayname: "21:00", value: 21, active: false },
        { displayname: "22:00", value: 22, active: false },
        { displayname: "23:00", value: 23, active: false },
      ],
      performance_report:[],
      totimedata: [
        { displayname: "00:59", value: 1, active: false },
        { displayname: "01:59", value: 2, active: false },
        { displayname: "02:59", value: 3, active: false },
        { displayname: "03:59", value: 4, active: false },
        { displayname: "04:59", value: 5, active: false },
        { displayname: "05:59", value: 6, active: false },
        { displayname: "06:59", value: 7, active: false },
        { displayname: "07:59", value: 8, active: false },
        { displayname: "08:59", value: 9, active: false },
        { displayname: "09:59", value: 10, active: false },
        { displayname: "10:59", value: 11, active: false },
        { displayname: "11:59", value: 12, active: false },
        { displayname: "12:59", value: 13, active: false },
        { displayname: "13:59", value: 14, active: false },
        { displayname: "14:59", value: 15, active: false },
        { displayname: "15:59", value: 16, active: false },
        { displayname: "16:59", value: 17, active: false },
        { displayname: "17:59", value: 18, active: false },
        { displayname: "18:59", value: 19, active: false },
        { displayname: "19:59", value: 20, active: false },
        { displayname: "20:59", value: 21, active: false },
        { displayname: "21:59", value: 22, active: false },
        { displayname: "22:59", value: 23, active: false },
        { displayname: "23:59", value: 24, active: false },
      ],
      from_date: "",
      to_date: "",
      dialog: false,
      appliedfilter: {
        campaign: "",
        fromdate: "",
        todate: "",
        agent: "",
        fromtime: 0,
        totime: 24
      },
      export_calls: "1",
      pagination: {
        rowsPerPage: 10,
      },

      headers1: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Start time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "start_time",
        }, {
          text: "End time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "end_time",
        },
        {
          text: "Campaign",
          align: "left",
          sortable: false,
          class: "p0",
          value: "campaign",
        },
        {
          text: "Agent",
          align: "left",
          sortable: false,
          class: "p0",
          value: "agent",
        },
        {
          text: "Team",
          align: "left",
          sortable: false,
          class: "p0",
          value: "team",
        },
        // {
        //   text: "Login Count",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "login_count",
        // },
        {
          text: "Total Calls",
          align: "left",
          sortable: false,
          class: "p0",
          value: "total",
        },
        {
          text: "Inbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundanswer",
        },
        {
          text: "Inbound Unanswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundunanswer",
        },
        {
          text: "Outbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundanswer",
        },
        {
          text: "Outbound Unanswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundunanswer",
        },
        // {
        //   text: "Answered",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "answered",
        // },
        // {
        //   text: "Unanswered",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "unanswered",
        // },
        // { text: "Inbound", align: "left", sortable: false, value: "inbound" },
        // { text: "Outbound", align: "left", sortable: false, value: "outbound" },
        // { text: "Preview", align: "left", sortable: false, value: "preview" },
        // { text: "Auto", align: "left", sortable: false, value: "dialer" }
      ],
     
      headers2: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Start time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "start_time",
        }, {
          text: "End time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "end_time",
        },
        {
          text: "Campaign",
          align: "left",
          sortable: false,
          class: "p0",
          value: "campaign",
        },
        {
          text: "Agent",
          align: "left",
          sortable: false,
          class: "p0",
          value: "agent",
        },
        {
          text: "Team",
          align: "left",
          sortable: false,
          class: "p0",
          value: "team",
        },
        // {
        //   text: "Login Count",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "login_count",
        // },
        {
          text: "Staff Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "login",
        },
        {
          text: "Billable break time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "billing_break",
        },
        {
          text: "Non-billable break time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "non_billing_break",
        },
        {
          text: "Total Break Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "break",
        },
        {
          text: "Total billable time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "total_billing_break",
        },
        {
          text: "Wrap Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "wrap",
        },
        {
          text: "Breach Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "breach",
        },
        // { text: "Handled Time", align: "left", sortable: false, value: "acw" },
        {
          text: "Talk Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "talktime",
        },
        // { text: "Hold Time", align: "left", sortable: false, value: "hold" },
        {
          text: "Idle Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "idle",
        },
        {
          text: "Avg Talk time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "avg",
        },
        {
          text: "Ring time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "ring",
        },
        {
          text: "Handle time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "handle_time",
        },
        
       
        
      ],
      agentperformancereport: [],
      agentperformancetotal: 0,
      pdf: {
        header: [
          { text: "Date", align: "left", sortable: true, value: "calldate" },
          { text: "Agent", align: "left", sortable: false, value: "agent" },
          {
            text: "Total Calls",
            align: "left",
            sortable: false,
            value: "total",
          },
          {
            text: "Inbound Answer",
            align: "left",
            sortable: false,
            value: "inboundanswer",
          },
          {
            text: "Inbound Unanswer",
            align: "left",
            sortable: false,
            value: "inboundunanswer",
          },
          {
            text: "Outbound Answer",
            align: "left",
            sortable: false,
            value: "outboundanswer",
          },
          {
            text: "Outbound Unanswer",
            align: "left",
            sortable: false,
            value: "outboundunanswer",
          },
          // {
          //   text: "Answered",
          //   align: "left",
          //   sortable: false,
          //   value: "answered",
          // },
          // {
          //   text: "Unanswered",
          //   align: "left",
          //   sortable: false,
          //   value: "unanswered",
          // },
          {
            text: "Staff Time",
            align: "left",
            sortable: false,
            value: "login",
          },
          {
            text: "Total Break Time",
            align: "left",
            sortable: false,
            value: "break",
          },
          {
            text: "Wrap Time",
            align: "left",
            sortable: false,
            class: "p0",
            value: "wrap",
          },
          {
            text: "Breach Time",
            align: "left",
            sortable: false,
            class: "p0",
            value: "breach",
          },
          {
            text: "Talk Time",
            align: "left",
            sortable: false,
            value: "talktime",
          },
          { text: "Idle Time", align: "left", sortable: false, value: "idle" },
          {
            text: "Avg Talk time",
            align: "left",
            sortable: false,
            value: "avg",
          },
          { text: "Acw Time", align: "left", sortable: false, value: "idle" },
          {
            text: "Avg Acw Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Handle Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Avg Handle Time",
            align: "left",
            sortable: false,
            value: "idle",
          },

          {
            text: "Ring Time",
            align: "left",
            sortable: false,
            value: "ring",
          },
          {
            text: "First Login Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Last Logout Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
        ],
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    "appliedfilter.fromdate"(val) {
      if (this.appliedfilter.todate && new Date(this.appliedfilter.todate) < new Date(val)) {
        this.appliedfilter.todate = ''; // Clear todate if it is less than fromdate
      }
      this.skip = 0;

    },
    "appliedfilter.fromtime"(newVal) {
      this.totimedata = this.totimedata.map(item => ({
        ...item,
        active: item.value <= newVal // Mark active for values less than or equal to the passed value
      }));
      const anyActive = this.totimedata.some(item => item.active === true);

      // If any item is active, clear appliedfilter.totime
      if (anyActive) {
        this.appliedfilter.totime = "";
      }
      this.skip = 0;
    },
    "appliedfilter.todate"() {

      this.skip = 0;

    },
    "appliedfilter.agent"() {
      this.skip = 0;

    },
    "appliedfilter.campaign"() {
      this.skip = 0;

    },
  },
  methods: {

    openPerformanceReportFilter: function () {
      this.page.isFilterOpen = true;
    },
    refreshPerformanceReportPage: function () {
      var scope = this;
      scope.dateformate();
      scope.refreshvalue();
      // scope.pagination.page=1
      scope.appliedfilter.agent = "";
      scope.appliedfilter.campaign = ""
      scope.appliedfilter.fromtime = 0;
      scope.appliedfilter.totime = 24
      scope.getDataFromApi();

    },
    exportPerformanceReportReport: function (option) {
      if (option == "PDF" || option == "Txt(Tab-Delimited)") {
        this.dialog = true;
      }
      ``;
      //var export_option = {export_formate : option , viewing : this.page.viewing};
      var export_option = { export_formate: option };
      this.export(export_option);
    },
    toggleClick: function (option) {
      this.page.viewing = option;
    },
    dateformate() {
      this.page.loading = false;
      this.to_date = new Date();
      this.to_date = moment(this.to_date).format("YYYY-MM-DD");
      var from_date1 = new Date();
      // var dateOffset = 24 * 60 * 60 * 1000 * 30;
      // from_date1.setTime(from_date1.getTime() - dateOffset);
      this.from_date = moment(from_date1).format("YYYY-MM-DD");
      this.appliedfilter.fromdate = this.from_date;
      this.appliedfilter.todate = this.to_date;

    },
    getDataFromApi() {
      var scope = this;
      var { descending } = scope.pagination;
      scope.payload.to_date = this.appliedfilter.todate;
      scope.payload.from_date = this.appliedfilter.fromdate;
      scope.payload.fromtime = scope.appliedfilter.fromtime;
      scope.payload.totime = scope.appliedfilter.totime;
      var { page, rowsPerPage } = scope.pagination;
      //scope.$store
      //  .dispatch("reportuserlist")
      //  .then((response) => {
      //    let dataa = response.toString(",");
      let team_name = ""
      let teams = JSON.parse(localStorage.getItem("Team"))
      let team_agent_user = JSON.parse(localStorage.getItem("Team_agent_user"))
      if (teams.length > 0 ) {
        scope.payload.agent = team_agent_user
        team_name = teams.map(elm => elm.name).flat()
      } else {
        scope.payload.agent = JSON.parse(localStorage.getItem("agent_emails"));
      }
      if (rowsPerPage == -1) {
        scope.payload.take = scope.total;
      } else if (
        rowsPerPage != "" &&
        rowsPerPage != undefined &&
        rowsPerPage != null
      ) {
        scope.payload.take = rowsPerPage;
      } else {
        scope.payload.take = 5;
      }
      if (page != "" && page != undefined && page != null) {
        scope.skip = page;
      } else {
        scope.skip = 1;
      }
      scope.payload.skip = (scope.skip - 1) * scope.payload.take;
      scope.payload.descending = descending;
      scope.payload.team_name = team_name
      scope.payload.selectedagent = scope.appliedfilter.agent
      scope.payload.campaign = scope.appliedfilter.campaign
      scope.$store
        .dispatch("HourlyPerformancereport", scope.payload)
        .then((response) => {
          scope.page.loading = false;
          scope.total = response.count;
          scope.performance_report=response.data
          // if (scope.page_flag) {
          //   scope.pagination.page = 1;
          //   scope.page_flag = false;
          // }
          scope.agentperformancetotal = scope.total;
          if (response.response.status === 401) {
            scope.$store.dispatch("checkingtoken");
          }
        });
      // });
      //})
    },
    getDataFrom() {
      this.skip = 0;
      this.getDataFromApi();
      this.page_flag = true;
      this.page.isFilterOpen = false
    },
    resetvalue() {
      this.skip = 0;
      var to_date = new Date();
      to_date = moment(to_date).format("YYYY-MM-DD");
      var from_date = new Date();
      // var dateOffset = 24 * 60 * 60 * 1000 * 30;
      // from_date.setTime(from_date.getTime() - dateOffset);
      from_date = moment(from_date).format("YYYY-MM-DD");
      this.$store.dispatch("fromdate", from_date);
      this.$store.dispatch("todate", to_date);
      this.appliedfilter.agent = "";
      this.appliedfilter.campaign = ""
      this.appliedfilter.flag = true;
      this.appliedfilter.fromdate = "";
      this.appliedfilter.fromtime = 0;
      this.appliedfilter.totime = 24;
      this.appliedfilter.todate = "";
      if (this.appliedfilter.flag) {
        this.appliedfilter.fromdate = from_date;
        this.appliedfilter.todate = to_date;
        this.appliedfilter.flag = false;
      }
      this.getDataFromApi();
      this.page.isFilterOpen = true;
    },
    closeModel: function () {
      this.dialog = false;
    },

    export(option) {
  this.excel_data = [];
  this.txt_data = [];
  let scope = this;

  var from_date = moment(this.payload.from_date).format("YYYY-MM-DD");
  var to_date = moment(this.payload.to_date).format("YYYY-MM-DD");
  let teams = JSON.parse(localStorage.getItem("Team"));
  let team_name = "";

  if (teams.length > 0) {
    team_name = teams.map(elm => elm.name).flat();
  }

  let export_date = {
    from_date: from_date,
    to_date: to_date,
    misseddetail: "hourlyPerformancereport",
    team_name: team_name,
    fromtime: scope.appliedfilter.fromtime,
    totime: scope.appliedfilter.totime,
    agent: scope.appliedfilter.agent,
    campaign: scope.appliedfilter.campaign,
    descending: false,
    team: ""
  };

  export_date.selectedagent = scope.appliedfilter.agent;

  this.$store.dispatch("exportdatafetch", export_date).then((response) => {
    this.exports = response;

    let txt_key = [
      "Start time", "End time", "Date", "Agent", "Agent Name", "Campaign",
      "Team", "Total Calls", "Inbound Answer", "Inbound Unanswer",
      "Outbound Answer", "Outbound Unanswer", "Wrap Time", "Breach Time",
      "Staff Time",'Billable break time','Non-billable break time', "Total Break Time",'Total billable time', "Talk Time", "Idle Time", "Avg Talk Time",
      "Ring Time", "Acw Time", "Avg Acw Time", "Handle Time", "Avg Handle Time",
      "First Login Time", "Last Logout Time"
    ];
    let csvContent = txt_key.join(",");

    for (let i = 0; i < this.exports.length; i++) {
      let changedate = response[i].calldate;

      let init_obj = {
        "Start time": response[i].start_time || "",
        "End time": response[i].end_time || "",
        "Date": changedate || "",
        "Agent": response[i].agent || "",
        "Agent Name": response[i].agent_name || "",
        "Campaign": response[i].campaign || "",
        "Team": response[i].team || "",
        "Total Calls": (response[i].answer || 0) + (response[i].unanswer || 0) + (response[i].inbound_unanswer || 0),
        "Inbound Answer": response[i].inbound || 0,
        "Inbound Unanswer": response[i].inbound_unanswer || 0,
        "Outbound Answer": response[i].outbound || 0,
        "Outbound Unanswer": response[i].unanswer || 0,
        "Wrap Time": response[i].wrap || "00:00:00",
        "Breach Time": response[i].breach || "00:00:00",
        "Staff Time": response[i].login || "00:00:00",
        'Billable break time':response[i].billing_break||"00:00:00",
        'Non-billable break time':response[i].non_billing_break||"00:00:00",
        "Total Break Time": response[i].break || "00:00:00",
        'Total billable time': response[i].total_billing_break || "00:00:00",
        "Talk Time": response[i].talktime || "00:00:00",
        "Idle Time": response[i].idle || "00:00:00",
        "Avg Talk Time": response[i].avg_talk || "00:00:00",
        "Ring Time": response[i].ring || "00:00:00",
        "Acw Time": response[i].acw || "00:00:00",
        "Avg Acw Time": response[i].avg_acw || "00:00:00",
        "Handle Time": response[i].handle_time || "00:00:00",
        "Avg Handle Time": response[i].avg_handle_time || "00:00:00",
        "First Login Time": response[i].first_login_time || "",
        "Last Logout Time": response[i].last_logout_time || ""
      };

      this.excel_data.push(init_obj);
      this.txt_data.push(init_obj);
    }

    if (option.export_formate === "CSV") {
      this.excel_data.forEach(function (rows) {
        let data = Object.values(rows).map(elm =>
          typeof elm === "string" ? elm.replace(/'|"|#|\n/g, " ").replace(/,/g, ";") : elm
        );
        let row = data.join(",");
        csvContent += "\r\n" + row;
      });

      let dateNow = moment(new Date()).format("YYYY-MM-DD hh-mm");
      const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `AgentHourlyPerformanceReport_${dateNow}.csv`);
      document.body.appendChild(link);
      link.click();
    }

    if (option.export_formate === "Txt(Tab-Delimited)") {
      let txtContent = txt_key.join("\t") + "\r\n";
      this.txt_data.forEach(function (rows) {
        let data = Object.values(rows).map(elm =>
          typeof elm === "string" ? elm.replace(/'|"|#|\n/g, " ") : elm
        );
        txtContent += data.join("\t") + "\r\n";
      });

      let dateNow = moment(new Date()).format("YYYY-MM-DD hh-mm");
      const encodedUri = "data:text/plain;charset=utf-8,\uFEFF" + encodeURIComponent(txtContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `AgentHourlyPerformanceReport_${dateNow}.txt`);
      document.body.appendChild(link);
      link.click();
    }
  });
},

    refreshvalue() {

      this.page_flag = true;
    },
  },


};
</script>
